import type { FC } from 'react';
import { AmountInput } from '@george-labs.com/design-system';
import type { AmountInputProps } from '@george-labs.com/design-system/types/components/Input/AmountInput';

import { getFeatureConfig } from '@luna/feature-config';

import { handleLocalizedCurrencyEvent, processValue } from './LocalizedAmountInputService';

type Props = AmountInputProps & { disableThousandSeparatorInput?: boolean };

export const LocalizedAmountInput: FC<Props> = ({
    precision = getFeatureConfig((config) => config.base.defaultPrecision),
    currency = getFeatureConfig((config) => config.base.defaultCurrency),
    onInput,
    onChange,
    onFormat,
    disableThousandSeparatorInput,
    ...restProps
}) => {
    return (
        <AmountInput
            decimalSeparator={getFeatureConfig((f) => f.base.decimalSeparator)}
            thousandSeparator={getFeatureConfig((f) => f.base.thousandSeparator)}
            {...restProps}
            onInput={handleLocalizedCurrencyEvent(onInput)}
            onChange={handleLocalizedCurrencyEvent(onChange)}
            // @ts-expect-error incompatible types
            onFormat={handleLocalizedCurrencyEvent(onFormat)}
            currency={currency}
            processValue={processValue(precision, disableThousandSeparatorInput)}
            precision={precision}
        />
    );
};
